import { useMemo } from 'react';
import './authn-layout.less';

import type { NOTIF_BANNER_TYPE } from '@imprivata-cloud/components';
import { NotificationSystem } from '@imprivata-cloud/design-system';
import { useTranslation } from 'react-i18next';

import { offlineBannerMetaData } from '@/utils/bannerUtils';

import ImprivataLogo from '../../assets/Imprivata_Logo.svg?react';
import { AuthenticationHeader } from './components/authentication-header/authentication-header';
import { EnrollmentHeader } from './components/enrollment-header/enrollment-header';
export enum LayoutHeaders {
  AUTHENTICATION = 'AUTHENTICATION',
  ENROLL_CONSENT = 'ENROLL_CONSENT',
}

interface AuthnLayoutProps {
  children: React.ReactNode;
  logoUrl?: string | React.ReactNode;
  hexImage?: React.ReactNode;
  header: LayoutHeaders;
  hideLayout?: boolean;
  // Severity of the banner on screen; the enroll header projects it onto its glyph.
  bannerStatus?: NOTIF_BANNER_TYPE;
}

export const AuthnLayout = ({
  children,
  logoUrl,
  hexImage,
  header,
  hideLayout,
  bannerStatus,
}: AuthnLayoutProps) => {
  const { t } = useTranslation();
  const loadLogo = useMemo(
    () =>
      typeof logoUrl === 'string' ? (
        <img src={logoUrl} alt="logo" className="card-header-logo" />
      ) : (
        logoUrl
      ),
    [logoUrl],
  );
  const offlineBanner = useMemo(() => {
    return offlineBannerMetaData(
      t('errors.offline'),
      t('errors.offline-sub-message'),
    );
  }, [t]);
  const renderHeader = useMemo(() => {
    switch (header) {
      case LayoutHeaders.AUTHENTICATION:
        return <AuthenticationHeader logoUrl={loadLogo} hexImage={hexImage} />;
      case LayoutHeaders.ENROLL_CONSENT:
        return (
          <EnrollmentHeader hexImage={hexImage} bannerStatus={bannerStatus} />
        );
      default:
        return null;
    }
  }, [header, loadLogo, hexImage, bannerStatus]);

  return (
    <div className={`authn-layout-root ${hideLayout && 'hide-layout'}`}>
      <NotificationSystem handleOffline={offlineBanner} dismissOnInteraction />
      {renderHeader}
      <div className="authn-layout-body">{children}</div>
      <div className="authn-layout-footer">
        <ImprivataLogo />
      </div>
    </div>
  );
};
